import { useDeviceOrientation } from '../../Utils/useDeviceOrientation';
import QrCode from '../QrCode';

const RequireMobile = ({ children }) => {
    const { isDesktop } = useDeviceOrientation();
    return isDesktop ? <QrCode /> : children;
};

export default RequireMobile;
